import api from '@/api/fetch'
import type { Customer, Promotion } from '@/types'

export function getCustomer(phoneNumber: string): Promise<Customer> {
  return api
    .get('/customers', {
      phoneNumber
    })
    .then(res => res.data)
}

export function getCustomerPromotions(customerId: string) {
  return api
    .get<{
      customerPromotions: Promotion[]
      customerUsedPromotions: string[]
      points: number
    }>(`/customer/${customerId}/promotions`)
    .then(res => res.data)
}
